<template>
<div>
  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-envelope"></span>
    </div>

    <div>
      <div>
      <h3>{{ company.name }}</h3>

      <p class="text-small">
        Ihr Ansprechpartner rund um die Immobilie.
      </p>

      <ul class="text-small list-unstyled" v-if="company.offices && company.offices.length">
        <li v-for="(office, i) in company.offices" :key="i" class="contact__office">
          <strong>{{ office.label }}</strong><br />
          {{ office.street }}<br />
          {{ office.zip }} {{ office.city }}
          <template v-if="office.note"><br />{{ office.note }}</template>
        </li>

        <li>
          <span>Telefon:</span>
          <a :href="'tel:' + company.phone" class="text-normal">
              {{ company.phone }}
          </a>
        </li>
      </ul>
      <ul class="text-small list-unstyled" v-else>
        <li>
          <span>Adresse:</span>
          {{ company.street }}<br />
          <span></span> {{ company.zip }} {{ company.city }}
        </li>

        <li>
          <span>Telefon:</span>
          <a :href="'tel:' + company.phone" class="text-normal">
              {{ company.phone }}
          </a>
        </li>
      </ul>
      </div>
    </div>
  </div>

  <div class="contact__info">
    <div class="first-col">
      <span class="fas fa-map-marker-alt"></span>
    </div>

    <div>
      <div>
        <h3>Ihr Weg zu uns</h3>

        <p class="text-small">
          Nehmen Sie mit uns Kontakt auf und vereinbaren Sie einen persönlichen Besprechungstermin. Wir freuen uns auf Sie.
        </p>

        <p>
          <a :href="'https://www.google.de/maps?daddr=' + company.street + ', ' + company.zip + '+' + company.city + '&saddr='"
            title="Route jetzt berechnen"
            target="_blank"
            class="link--arrow">
              Route jetzt berechnen
          </a>
        </p>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "ContactCompanyInfo",

  computed: {
    company() {
      return this.$yeti.company();
    }
  },

  methods: {
    onMapLoad(o) {
      o.L.marker(o.defaultCenter).addTo(o.map);
      this.mapCenter = o.defaultCenter;
    }
  }
}
</script>
